import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl,
	FormControlLabel,
	FormLabel,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	SelectChangeEvent,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	TextField,
} from "@mui/material";
import Header from "../../../components/layouts/header";
import Sidebar from "../../../components/layouts/sidebar";
import {
	Add,
	ArrowDownwardOutlined,
	ArrowUpwardOutlined,
	CloseOutlined,
	Delete,
	Edit,
} from "@mui/icons-material";
import React from "react";

const Budget: React.FC = () => {
	// Table Pagination
	const [page, setPage] = React.useState(2);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const handleChangePage = (
		event: React.MouseEvent<HTMLButtonElement> | null,
		newPage: number
	) => {
		setPage(newPage);
	};
	const handleChangeRowsPerPage = (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	// Dialog
	const [dialogOpen, setDialogOpen] = React.useState(false);
	const dialogHandleClickOpen = () => {
		setDialogOpen(true);
	};
	const dialogHandleClose = () => {
		setDialogOpen(false);
	};

	const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
	const deleteDialogHandleClickOpen = () => {
		setDeleteDialogOpen(true);
	};
	const deleteDialogHandleClose = () => {
		setDeleteDialogOpen(false);
	};

	// Select
	const [selectPropertyType, setSelectPropertyType] = React.useState("");
	const selectPropertyTypeChange = (event: SelectChangeEvent) => {
		setSelectPropertyType(event.target.value as string);
	};

	const [selectSegment, setSelectSegment] = React.useState("");
	const selectSegmentChange = (event: SelectChangeEvent) => {
		setSelectSegment(event.target.value as string);
	};

	const [selectBhkOffice, setSelectBhkOffice] = React.useState("");
	const selectBhkOfficeChange = (event: SelectChangeEvent) => {
		setSelectBhkOffice(event.target.value as string);
	};

	return (
		<div className="main-content">
			<Header />
			<div className="page-content">
				<Sidebar />
				<div className="page-inner">
					<div className="page-heading-wrapper">
						<h4 className="page-heading">Budget</h4>
						<IconButton
							aria-label="add"
							color="primary"
							className="primary-icon"
							onClick={dialogHandleClickOpen}
						>
							<Add />
						</IconButton>
					</div>
					<div className="white-paper">
						<div className="table-heading-block">
							<TextField label="Search" variant="outlined" />
						</div>
						<div className="table-negative-space">
							<TableContainer>
								<Table aria-label="simple table">
									<TableHead>
										<TableRow>
											<TableCell>
												For
												<IconButton aria-label="Sort" className="sort-icon">
													<ArrowDownwardOutlined />
												</IconButton>
											</TableCell>
											<TableCell>
												Name
												<IconButton aria-label="Sort" className="sort-icon">
													<ArrowUpwardOutlined />
												</IconButton>
											</TableCell>
											<TableCell>
												Bhk/Office
												<IconButton aria-label="Sort" className="sort-icon">
													<ArrowUpwardOutlined />
												</IconButton>
											</TableCell>
											<TableCell>
												Type
												<IconButton aria-label="Sort" className="sort-icon">
													<ArrowUpwardOutlined />
												</IconButton>
											</TableCell>
											<TableCell>
												Segment
												<IconButton aria-label="Sort" className="sort-icon">
													<ArrowUpwardOutlined />
												</IconButton>
											</TableCell>
											<TableCell>
												Actives
												<IconButton aria-label="Sort" className="sort-icon">
													<ArrowDownwardOutlined />
												</IconButton>
											</TableCell>
											<TableCell className="action-col" align="center">
												Action
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow>
											<TableCell>Buy</TableCell>
											<TableCell>30-50 Lac</TableCell>
											<TableCell>2 BHK</TableCell>
											<TableCell>Residential</TableCell>
											<TableCell>Flat</TableCell>
											<TableCell>
												<FormControlLabel
													control={<Checkbox defaultChecked />}
													label="Active"
												/>
											</TableCell>
											<TableCell className="action-col" align="center">
												<div className="button-wrapper">
													<IconButton
														aria-label="Edit"
														color="primary"
														onClick={dialogHandleClickOpen}
													>
														<Edit />
													</IconButton>
													<IconButton
														aria-label="Delete"
														color="primary"
														onClick={deleteDialogHandleClickOpen}
													>
														<Delete />
													</IconButton>
												</div>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Buy</TableCell>
											<TableCell>50-70 Lac</TableCell>
											<TableCell>3 Bhk</TableCell>
											<TableCell>Residential</TableCell>
											<TableCell>Flat</TableCell>
											<TableCell>
												<FormControlLabel
													control={<Checkbox defaultChecked />}
													label="Active"
												/>
											</TableCell>
											<TableCell className="action-col" align="center">
												<div className="button-wrapper">
													<IconButton
														aria-label="Edit"
														color="primary"
														onClick={dialogHandleClickOpen}
													>
														<Edit />
													</IconButton>
													<IconButton
														aria-label="Delete"
														color="primary"
														onClick={deleteDialogHandleClickOpen}
													>
														<Delete />
													</IconButton>
												</div>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Buy</TableCell>
											<TableCell>70-1 CR</TableCell>
											<TableCell>3 Bhk</TableCell>
											<TableCell>Residential</TableCell>
											<TableCell>Flat</TableCell>
											<TableCell>
												<FormControlLabel
													control={<Checkbox defaultChecked />}
													label="Active"
												/>
											</TableCell>
											<TableCell className="action-col" align="center">
												<div className="button-wrapper">
													<IconButton
														aria-label="Edit"
														color="primary"
														onClick={dialogHandleClickOpen}
													>
														<Edit />
													</IconButton>
													<IconButton
														aria-label="Delete"
														color="primary"
														onClick={deleteDialogHandleClickOpen}
													>
														<Delete />
													</IconButton>
												</div>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Buy</TableCell>
											<TableCell>1CR-1.5CR</TableCell>
											<TableCell>4 Bhk</TableCell>
											<TableCell>Residential</TableCell>
											<TableCell>Flat</TableCell>
											<TableCell>
												<FormControlLabel
													control={<Checkbox defaultChecked />}
													label="Active"
												/>
											</TableCell>
											<TableCell className="action-col" align="center">
												<div className="button-wrapper">
													<IconButton
														aria-label="Edit"
														color="primary"
														onClick={dialogHandleClickOpen}
													>
														<Edit />
													</IconButton>
													<IconButton
														aria-label="Delete"
														color="primary"
														onClick={deleteDialogHandleClickOpen}
													>
														<Delete />
													</IconButton>
												</div>
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</div>
						<div className="pagination-wrapper">
							<TablePagination
								component="div"
								count={100}
								page={page}
								onPageChange={handleChangePage}
								rowsPerPage={rowsPerPage}
								onRowsPerPageChange={handleChangeRowsPerPage}
							/>
						</div>
					</div>
				</div>

				{/* Add New Dialog */}
				<Dialog
					open={dialogOpen}
					onClose={dialogHandleClose}
					maxWidth="sm"
					fullWidth
				>
					<DialogTitle>
						Add New Budget
						<IconButton aria-label="Close" onClick={dialogHandleClose}>
							<CloseOutlined />
						</IconButton>
					</DialogTitle>
					<DialogContent>
						<Grid container spacing={2} alignItems="center">
							<Grid item xs={12} sm={6}>
								<FormControl className="grid-radio radio-control">
									<FormLabel id="demo-row-radio-buttons-group-label">
										For
									</FormLabel>
									<RadioGroup
										row
										aria-labelledby="demo-row-radio-buttons-group-label"
										name="row-radio-buttons-group"
									>
										<FormControlLabel
											value="rent"
											control={<Radio />}
											label="Rent"
										/>
										<FormControlLabel
											value="buy"
											control={<Radio />}
											label="Buy"
										/>
									</RadioGroup>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									id="name"
									label="Name"
									type="text"
									fullWidth
									variant="outlined"
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									id="from"
									label="From"
									type="text"
									fullWidth
									variant="outlined"
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									id="to"
									label="To"
									type="text"
									fullWidth
									variant="outlined"
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<FormControl fullWidth>
									<InputLabel id="select-label">Property Type</InputLabel>
									<Select
										labelId="select-label"
										id="simple-select"
										value={selectPropertyType}
										label="Property Type"
										onChange={selectPropertyTypeChange}
									>
										<MenuItem value="PhoneCall">Phone Call</MenuItem>
										<MenuItem value="visit">Visit</MenuItem>
										<MenuItem value="meeting">Meeting</MenuItem>
										<MenuItem value="deal">Deal</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={6}>
								<FormControl fullWidth>
									<InputLabel id="segment-label">Segment</InputLabel>
									<Select
										labelId="segment-label"
										id="segment-select"
										value={selectSegment}
										label="Segment"
										onChange={selectSegmentChange}
									>
										<MenuItem value="PhoneCall">Phone Call</MenuItem>
										<MenuItem value="visit">Visit</MenuItem>
										<MenuItem value="meeting">Meeting</MenuItem>
										<MenuItem value="deal">Deal</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={6}>
								<FormControl fullWidth>
									<InputLabel id="bhk-office-label">Bhk/Office:</InputLabel>
									<Select
										labelId="bhk-office-label"
										id="bhk-office-select"
										value={selectBhkOffice}
										label="Bhk/Office:"
										onChange={selectBhkOfficeChange}
									>
										<MenuItem value="PhoneCall">Phone Call</MenuItem>
										<MenuItem value="visit">Visit</MenuItem>
										<MenuItem value="meeting">Meeting</MenuItem>
										<MenuItem value="deal">Deal</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={6}>
								<FormControlLabel
									control={<Checkbox defaultChecked />}
									label="Active"
								/>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button variant="contained" onClick={dialogHandleClose}>
							Submit
						</Button>
						<Button variant="outlined" onClick={dialogHandleClose}>
							Cancel
						</Button>
					</DialogActions>
				</Dialog>

				{/* Delete Dialog */}
				<Dialog
					open={deleteDialogOpen}
					onClose={deleteDialogHandleClose}
					maxWidth="xs"
					fullWidth
				>
					<DialogTitle>
						Delete Confirmation
						<IconButton aria-label="Close" onClick={deleteDialogHandleClose}>
							<CloseOutlined />
						</IconButton>
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Are you sure want to delete this recored?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							variant="contained"
							color="error"
							onClick={deleteDialogHandleClose}
						>
							Delete
						</Button>
						<Button variant="outlined" onClick={deleteDialogHandleClose}>
							Cancel
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</div>
	);
};
export default Budget;
